import React, { FC } from 'react'
import clsx from 'clsx'

import styles from '../Navbar.module.scss'
import { StandardProps } from '../../../types/common'

interface NavbarRightProps extends StandardProps {
  isScrollable?: boolean
}

export const NavbarRight: FC<NavbarRightProps> = ({
  children,
  className,
  style,
  isScrollable = false,
  testid = 'navbar-right',
  ...props
}) => {
  return (
    <>
      <div
        className={clsx(styles['hds-navbar__right'], className)}
        style={style}
        data-testid={testid}
        {...props}
      >
        {children}
      </div>
    </>
  )
}
